import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const ListOfLawyers = () => {
  const navigate = useNavigate();
  const [lawyers, setLawyers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLawyers = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch("https://admindashboard.clns.in/api/dashboard/advocate_status/", {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        
        
        if (!response.ok) {
          throw new Error('Failed to fetch lawyers');
        }
        
        const data = await response.json();
        console.log(data,"datass")
        setLawyers(data.advocates);
      } catch (error) {
        console.error("Error fetching lawyers:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchLawyers();
  }, []);

  const handleSelect = (id) => {
    console.log("Selected lawyer ID:", id); // Debug log
    navigate("/lawyer-details", { 
      state: { advocateId: id }
    });
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div style={styles.page}>
      <h3 style={styles.title}>List OF Lawyers</h3>

      <div style={styles.gridContainer}>
        <div style={styles.tableContainer}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.header}>Lawyer Name</th>
                <th style={styles.header}>Phone no.</th>
                <th style={styles.header}>Mail ID</th>
                <th style={styles.header}>Location</th>
                <th style={styles.header}></th>
              </tr>
            </thead>
            <tbody>
              {lawyers.map((lawyer) => (
                <tr key={lawyer.id} style={styles.row}>
                  <td style={styles.cell}>{`${lawyer.first_name} ${lawyer.last_name}`}</td>
                  <td style={styles.cell}>{lawyer.phone_number}</td>
                  <td style={styles.cell}>{lawyer.email}</td>
                  <td style={styles.cell}>{lawyer.city}</td>
                  <td style={styles.buttonCell}>
                    <button
                      style={styles.addButton}
                      onClick={() => handleSelect(lawyer.id)}
                    >
                      Select
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const styles = {
  page: {
    display: "grid",
    gap: "20px",
    padding: "2%",
    backgroundColor: "#f9f9f9",
  },
  title: { fontSize: "20px", fontWeight: "bold", textAlign: "center" },
  tableContainer: {
    border: "1px solid #ddd",
    borderRadius: "5px",
    backgroundColor: "white",
    overflowX: "auto",
  },
  table: { borderCollapse: "collapse", width: "100%" },
  header: {
    backgroundColor: "#f4f4f4",
    padding: "10px",
    border: "1px solid #ddd",
  },
  cell: { padding: "10px", border: "1px solid #ddd", textAlign: "center" },
  buttonCell: { padding: "5px", textAlign: "center" },
  addButton: {
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    padding: "5px 10px",
    borderRadius: "5px",
    cursor: "pointer",
  },
};

export default ListOfLawyers;